import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";

export const Seasons = () => {
  return (
    <section
      data-testid="seasons-section"
      className="relative overflow-hidden bg-[#1c2419]"
    >
      <div className="relative flex h-[560px] w-full flex-col sm:h-[620px] sm:flex-row">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="group relative h-1/2 w-full overflow-hidden sm:h-full sm:w-1/2"
        >
          <img
            src={IMAGES.hamakTaras}
            alt="Taras z jacuzzi i hamakiem latem"
            className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
          <span className="absolute left-6 top-5 text-xs font-semibold uppercase tracking-[0.35em] text-white/85 sm:bottom-8 sm:left-8 sm:top-auto">
            Lato
          </span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="group relative h-1/2 w-full overflow-hidden sm:h-full sm:w-1/2"
        >
          <img
            src={IMAGES.jacuzziZima}
            alt="Taras z jacuzzi i hamakiem zimą"
            className="h-full w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
          <span className="absolute bottom-6 right-6 text-xs font-semibold uppercase tracking-[0.35em] text-white/85 sm:bottom-8 sm:right-8">
            Zima
          </span>
        </motion.div>

        {/* seam darkening so the headline reads over either photo */}
        <div className="pointer-events-none absolute inset-x-0 top-1/2 h-44 -translate-y-1/2 bg-gradient-to-b from-transparent via-black/50 to-transparent sm:inset-x-auto sm:inset-y-0 sm:left-1/2 sm:top-0 sm:h-full sm:w-64 sm:-translate-x-1/2 sm:translate-y-0 sm:bg-gradient-to-r" />
        <div className="pointer-events-none absolute left-1/2 top-0 hidden h-full w-px -translate-x-1/2 bg-white/25 sm:block" />

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="pointer-events-none absolute inset-0 flex items-center justify-center px-6 text-center"
        >
          <div>
            <p className="font-brand text-4xl text-white drop-shadow-md md:text-6xl">
              365 dni w roku
            </p>
            <p className="mx-auto mt-4 max-w-sm text-sm leading-relaxed text-white/90 md:text-base">
              To samo miejsce nad jeziorem Juno — latem i zimą zawsze gotowe
              na Wasz przyjazd.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
